import { render, staticRenderFns } from "./NavigationBarCareProvidersMenu.vue?vue&type=template&id=0b609cb3&scoped=true&"
import script from "./NavigationBarCareProvidersMenu.vue?vue&type=script&lang=js&"
export * from "./NavigationBarCareProvidersMenu.vue?vue&type=script&lang=js&"
import style0 from "./NavigationBarCareProvidersMenu.vue?vue&type=style&index=0&id=0b609cb3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b609cb3",
  null
  
)

export default component.exports